import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import Report from "Components/Report";
import ls from "Localization";
import ISplit from "Types/Split";
import { toStringCurrency } from "helpers/string";
import { InvoiceState } from "store/reducers/invoice";
import ReactTable from "react-table";
import _ from "lodash";
import IInvoice from "Types/Invoice";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { NFSeStatus } from "Types/INFSe";
import { CNPJ } from "Components/NumberFormat";

dayjs.extend(utc);

let getInvoicesDebounced: (() => any) & _.Cancelable;

function Invoices({ id }) {
	const dispatch = useDispatch<any>();
	const table = useRef<ReactTable<any>>(null);

	const state = useSelector<State, InvoiceState>(s => s.invoice);

	const handleFetchData = (tableState: any) => {
		if (!tableState) return;
		const { page, pageSize, toExport, callback } = tableState;
		let { sorted, filtered } = tableState;

		if (getInvoicesDebounced) {
			getInvoicesDebounced.cancel();
		}

		if (!sorted) sorted = [];

		filtered = [...(filtered || [])];

		const creationDate = filtered.find((c: any) => c.id === "creationDate");

		if (creationDate?.value) {
			filtered = filtered.filter((c: any) => c.id !== "creationDate");

			if (creationDate?.value.startDate) {
				filtered.push({
					id: "startDate",
					value: creationDate.value.startDate
				});
			}

			if (creationDate?.value.endDate)
				filtered.push({
					id: "endDate",
					value: creationDate.value.endDate
				});
		}

		filtered.push({
			id: "meiId",
			value: id
		});

		getInvoicesDebounced = _.debounce(
			() =>
				dispatch(
					actions.invoice.getInvoices(
						page * pageSize,
						pageSize,
						filtered.reduce(
							(p: any, c: any) => p + `&filters[${c.id}]=${c.value}`,
							""
						),
						sorted[0]?.id,
						sorted[0]?.desc,
						toExport,
						callback
					)
				),
			500
		);

		getInvoicesDebounced();
	};

	const load = () => handleFetchData(table.current?.state);

	return (
		<Report
			manual
			tableRef={table}
			title="Notas fiscais"
			onFetchData={handleFetchData}
			data={state.items}
			pages={state.pages}
			loading={state.loading.getAll}
			columns={[
				{
					Header: ls.emissionDate,
					id: "date",
					show: true,
					accessor: (c: IInvoice) =>
						dayjs.utc(c.date).format(ls.dateFormatShort),
					width: 180
				},
				{
					Header: "NFS-e",
					id: "nfse",
					show: true,
					accessor: (c: IInvoice) => c.nfse
				},
				{
					Header: "Tomador",
					id: "cnpj",
					show: true,
					accessor: (c: IInvoice) => <CNPJ value={c.cnpj} displayType="text" />,
					width: 180
				},
				{
					Header: "Cidade",
					id: "city",
					show: true,
					accessor: (c: IInvoice) => c.city,
					width: 150
				},
				{
					Header: ls.value,
					id: "value",
					show: true,
					filterable: false,
					accessor: (c: ISplit) => toStringCurrency(+c.value / 100.0),
					width: 150
				},
				{
					Header: ls.status,
					id: "status",
					show: true,
					accessor: (c: IInvoice) => ls[NFSeStatus[c.status]],
					width: 100
				}
			]}
			defaultSorted={[
				{
					id: "date",
					desc: true
				}
			]}
			filterable={false}
			getTdProps={() => {
				return {
					style: {
						display: "flex",
						alignItems: "center"
					}
				};
			}}
		/>
	);
}

export default Invoices;
